export const createStyleMutation = /* GraphQL */ `
mutation CreateStyle($input: createStyle!) {
    createStyle(input: $input) {
        id
    }
}
`
